<template>
  <v-card class="helmi-card">
    <div class="helmi-card-title pl-6 pt-6">
      Muokkaa tietoja
    </div>
    <v-card-text>
      <v-text-field
        v-model="offerer.nimi"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="person"
        label="Nimi"
      />
      <v-text-field
        v-model="offerer.sotu"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="verified_user"
        label="Henkilötunnus / y-tunnus"
      />
      <v-text-field
        v-model="offerer.email"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="email"
        label="Sähkoposti"
      />
      <template v-if="isBusiness(offerer.sotu) && individualSellers.length">
        <p class="mt-4">
          Onko myyjä ostajayhteisön osakas / yhtiömies, tai onko myyjä ostajayhteisön osakkaan tai
          yhtiömiehen vanhempi, puoliso tai lapsi?
        </p>
        <v-select
          v-for="(company, index) in individualSellers"
          :key="index"
          v-model="company.InterestCorporateBuyerIndividualSeller"
          :label="company.nimi"
          :items="InterestCorporateBuyerIndividualSellerValues"
          hide-details
          class="mt-4"
          outlined
        />
      </template>
      <template v-if="isBusiness(offerer.sotu) === false && companySellers.length">
        <p class="mt-4">
          Jos myyjä on yritys, onko ostaja osakas / yhtiömies myyjäyhtiössä, tai onko ostaja
          osakkaan tai yhtiömiehen vanhempi, lapsi tai puoliso?
        </p>
        <v-select
          v-for="(company, index) in companySellers"
          :key="index"
          v-model="company.InterestIndividualBuyerCorporateSeller"
          :label="company.nimi"
          :items="InterestIndividualBuyerCorporateSellerValues"
          hide-details
          class="mt-4"
          outlined
        />
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="closeDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="sending"
        @click="saveOffererDetails()"
      >
        Tallenna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'EditOfferer',
  props: {
    offerer: {
      type: Object,
      default: () => ({
        sotu: '',
        nimi: '',
        email: '',
        interestDetail: '',
      }),
    },
  },
  data: () => ({
    companySellers: [],
    individualSellers: [],
    sending: false,
    InterestCorporateBuyerIndividualSellerValues: [
      {
        text: 'Kyllä',
        value: true,
      },
      {
        text: 'Ei',
        value: false,
      },
    ],
    InterestIndividualBuyerCorporateSellerValues: [
      {
        text: 'Kyllä',
        value: true,
      },
      {
        text: 'Ei',
        value: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      currentProperty: state => state.currentProperty,
    }),
  },
  watch: {
    offerer: {
      async handler() {
        this.resetCustomer();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.resetCustomer();
  },
  methods: {
    ...mapActions({
      updateCustomer: 'updateCustomer',
      updateInterestDetail: 'updateInterestDetail',
    }),
    closeDialog() {
      this.$bus.$emit('closeOffererDialog');
    },
    isBusiness(value) {
      if (value.length === 9) return true;
      return false;
    },
    async saveOffererDetails() {
      this.sending = true;
      const interestDetail = this.isBusiness(this.offerer.sotu) === false
        ? this.companySellers : this.individualSellers;
      await this.updateCustomer(this.offerer);
      await this.updateInterestDetail({
        ...this.offerer,
        interestDetail,
      });
      this.sending = false;
      this.$bus.$emit('reload');
      this.$bus.$emit('closeOffererDialog');
    },
    resetCustomer() {
      this.companySellers = _.cloneDeep(this.currentProperty
        .sellers.filter(s => this.isBusiness(s.sotu)))
        .map((seller) => {
          let value = false;
          if (
            this.offerer.interestDetail
            && this.offerer.interestDetail.length
            && this.offerer.interestDetail
              .some(s => s.id === seller.henkilo_id
                && Object.prototype.hasOwnProperty.call(s, 'InterestIndividualBuyerCorporateSeller'))
          ) {
            value = this.offerer.interestDetail
              .find(s => s.id === seller.henkilo_id).InterestIndividualBuyerCorporateSeller;
          }
          return {
            nimi: seller.nimi,
            id: seller.henkilo_id,
            InterestIndividualBuyerCorporateSeller: value,
          };
        });
      this.individualSellers = _.cloneDeep(this.currentProperty
        .sellers.filter(s => this.isBusiness(s.sotu) === false))
        .map((seller) => {
          let value = false;
          if (
            this.offerer.interestDetail
            && this.offerer.interestDetail
              .some(s => s.id === seller.henkilo_id
                && Object.prototype.hasOwnProperty.call(s, 'InterestCorporateBuyerIndividualSeller'))
          ) {
            value = this.offerer.interestDetail
              .find(s => s.id === seller.henkilo_id).InterestCorporateBuyerIndividualSeller;
          }
          return {
            nimi: seller.nimi,
            id: seller.henkilo_id,
            InterestCorporateBuyerIndividualSeller: value,
          };
        });
    },
  },
};
</script>
